import React from 'react';
import './index.scss';

const MetricCard = ({ header, body, footer }) => {
  return (
    <div className="metric-card">
      <div className="metric-card-header">{header}</div>
      <div className="metric-card-body">{body}</div>
      <div className="metric-card-footer">{footer}</div>
    </div>
  );
};

export default MetricCard;
